import React from 'react';
import { Route } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import Home from '../components/Home';

import ProtectedRoute from './ProtectedRoute';
import AdminLogin from '../modules/admin/AdminLogin';
import AdminRegister from "../modules/admin/AdminRegistration";
import AdminLayout from "../modules/admin/AdminLayout";
//this taken because every host and accees all the authors
import VerifyAuthor from '../modules/host/VerifyAuthor';
import AdminVerifyReviewer from '../modules/admin/AdminVerifyReviewer';
import AdminAssignSubmission from '../modules/admin/AdminAssignSubmission';
import AdminReviewRepliesList from '../modules/admin/AdminReviewRepliesList';
import AdminDecMatrix from '../modules/admin/AdminDecMatrix';
import PlatformManager from '../modules/host/PlatformManager';
import AuthorsList from '../modules/host/AuthorsList';
import AdminReviewerList from '../modules/admin/AdminReviewerList';
import AdminSubmissionList from '../modules/admin/AdminSubmissionList';
import AdminVerifyHost from '../modules/admin/AdminVerifyHost';
import AdminDashboard from '../modules/admin/AdminDashboard';
import AdminRegisterHost from '../modules/admin/AdminRegisterHost';



const AdminRoutes = (
  <>
  {/* hiding this because we do want to register a new admin  */}
    {/* <Route path="/admin-register" element={<AdminRegister />} /> */}
    <Route path="/login-admin" element={<AdminLogin />} />

    <Route element={<ProtectedRoute requiredRole="admin" />}>
      <Route path="/admin" element={<AdminLayout />}>
        <Route path="dashboard" element={< AdminDashboard />} />
        <Route path="verify-author" element={< VerifyAuthor />} />
        <Route path="verify-reviewer" element={<AdminVerifyReviewer />} />
        <Route path="submission-assignment" element={<AdminAssignSubmission />} />
        <Route path="review-replies-list" element={<AdminReviewRepliesList />} />
        <Route path="reviewer-decision-matrix" element={<AdminDecMatrix />} />
        {/* as it from host module */}
        <Route path="platforms" element={<PlatformManager />} />
        {/* author list as it from host module */}
        <Route path="authors-list" element={<AuthorsList />} />
        <Route path="reviewer-list" element={<AdminReviewerList />} />
        <Route path="submission-list" element={<AdminSubmissionList />} />
        <Route path="verify-hosts" element={<AdminVerifyHost />} />
        <Route path="register-host" element={<AdminRegisterHost/>}/>
      </Route>
    </Route>
  </>
);

export default AdminRoutes;
